export const CALL_MISSED_TOAST_DURATION = 8 * 3600 * 1000; // 8h
